import Component from 'component';
class CustomFormSelection extends Component {
  constructor(el, config) {
    super(el, config);
  }
  setupDefaults() {
    this.dom = {
      select: this.$el.find('select')
    }
    this.initSelect2();
  }
  initSelect2() {
    this.dom.select.select2(this.config);
  }
}
export default CustomFormSelection



// WEBPACK FOOTER //
// ./src/cc/js/components/CustomFormSelection.js